import Home from "./home/index.js";
import Staff from "./staff/index.js";
import EstateIndex from "./estate/index.js";
import EstateDetail from "./estate/detail.js";
import SearchArea from "./search/area.js";
import SearchStation from "./search/station.js";
import SearchSchool from "./search/school.js";
import SearchMap from "./search/map/index.js";
import Assessment from "./assessment/index.js";
import SoldIndex from "./sold/index.js";
import Company from "./company/index.js";
import Sell from "./sell/index.js";
import sold from "./sold/index.js";
import SoldResult from "./sold/result.js";
import SoldDetail from "./sold/detail.js";

const pages = () => {
    Home();
    Staff();
    EstateIndex();
    SoldIndex();
    EstateDetail();
    SearchArea();
    SearchStation();
    SearchSchool();
    SearchMap();
    Assessment();
    Company();
    Sell()
    sold();
    SoldResult();
    SoldDetail();
};
export default pages;
